module.exports = __webpack_public_path__ + "static/media/gu.b08ac0bd.svg";